import React, { ReactElement } from 'react'

export const SortingAZ = (): ReactElement => (
    <svg viewBox='0 0 32 32' enableBackground='new 0 0 32 32' width='24px' height='24px' xmlSpace='preserve'>
        <line
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            x1='23'
            y1='26.1'
            x2='23'
            y2='5'
        />
        <polyline
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            points='18.7,21.8 23,26.1 27.3,21.8 '
        />
        <polyline
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            points='12,15 12,14 9.1,6 8.9,6 6,14 6,15 '
        />
        <line fill='none' stroke='currentColor' strokeWidth='2' strokeMiterlimit='10' x1='6' y1='12' x2='12' y2='12' />
        <polyline
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            points='5,18 12,18 12,19 6,25 6,26 13,26 '
        />
    </svg>
)
